const qs = require('qs');

export const stringifyGetParams = params => {
  return qs.stringify(filterNonNull(params), {arrayFormat: 'repeat'})
}

function filterNonNull(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([k, v]) => v !== null));
}
